/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2018. All Rights Reserved.
 #*
 #*===================================================================
 */

/* tslint:disable:max-classes-per-file */
// tslint:disable:max-classes-per-file 
import { Action } from '@ngrx/store';

// send form to register user
export const GET_USER_BY_TOKEN = '[Login] Get User Data by Access Token';
export const GET_USER_BY_TOKEN_SUCCESS = '[Login] Get User Data by Access Token Success';
export const GET_USER_BY_TOKEN_FAIL = '[Login] Get User Data by Access Token Fail';

export const GET_USER_BY_ID = '[Login] Get User Data by ID';
export const GET_USER_BY_ID_SUCCESS = '[Login] Get User Data by ID Success';
export const GET_USER_BY_ID_FAIL = '[Login] Get User Data by ID Fail';

export const USER_LOGIN = '[Login] User Login';
export const USER_LOGIN_FAIL = '[Login] User Login Fail';
export const USER_LOGIN_SUCCESS = '[Login] User Login Success';

export const UPDATE_USER_DATA = '[Login] Update User Data';
export const UPDATE_USER_DATA_FAIL = '[Login] Update User Data Fail';
export const UPDATE_USER_DATA_SUCCESS = '[Login] Update User Data Success';

export const REFRESH_USER_DATA = '[Login] Refresh User Data';
export const REFRESH_USER_DATA_FAIL = '[Login] Refresh User Data Fail';
export const REFRESH_USER_DATA_SUCCESS = '[Login] Refresh User Data Success';

export const USER_LOGOUT = '[Login] User Logout';
export const USER_LOGOUT_FAIL = '[Login] User Logout Fail';
export const USER_LOGOUT_SUCCESS = '[Login] User Logout Success';

export class GetUserByToken implements Action {
  readonly type = GET_USER_BY_TOKEN;

  constructor(public payload: any) {}
}

export class GetUserByTokenSuccess implements Action {
  readonly type = GET_USER_BY_TOKEN_SUCCESS;

  constructor(public payload: any) {}
}

export class GetUserByTokenFail implements Action {
  readonly type = GET_USER_BY_TOKEN_FAIL;

  constructor(public payload: any) {}
}

export class GetUserById implements Action {
  readonly type = GET_USER_BY_ID;

  constructor(public payload: any) {}
}

export class GetUserByIdSuccess implements Action {
  readonly type = GET_USER_BY_ID_SUCCESS;

  constructor(public payload: any) {}
}

export class GetUserByIdFail implements Action {
  readonly type = GET_USER_BY_ID_FAIL;

  constructor(public payload: any) {}
}

export class UserLogin implements Action {
  readonly type = USER_LOGIN;

  constructor(public payload: any) {}
}

export class UserLoginFail implements Action {
  readonly type = USER_LOGIN_FAIL;

  constructor(public payload: any) {}
}

export class UserLoginSuccess implements Action {
  readonly type = USER_LOGIN_SUCCESS;

  constructor(public payload: any) {}
}

export class UpdateUserData implements Action {
  readonly type = UPDATE_USER_DATA;

  constructor(public payload: any) {}
}

export class UpdateUserDataFail implements Action {
  readonly type = UPDATE_USER_DATA_FAIL;

  constructor(public payload: any) {}
}

export class UpdateUserDataSuccess implements Action {
  readonly type = UPDATE_USER_DATA_SUCCESS;

  constructor(public payload: any) {}
}

export class RefreshUserData implements Action {
  readonly type = REFRESH_USER_DATA;
}

export class RefreshUserDataFail implements Action {
  readonly type = REFRESH_USER_DATA_FAIL;

  constructor(public payload: any) {}
}

export class RefreshUserDataSuccess implements Action {
  readonly type = REFRESH_USER_DATA_SUCCESS;

  constructor(public payload: any) {}
}

export class UserLogout implements Action {
  readonly type = USER_LOGOUT;
}

export class UserLogoutFail implements Action {
  readonly type = USER_LOGOUT_FAIL;

  constructor(public payload: any) {}
}

export class UserLogoutSuccess implements Action {
  readonly type = USER_LOGOUT_SUCCESS;

  constructor(public payload: any) {}
}

// action types
export type UserDataAction =
  | GetUserByToken
  | GetUserByTokenSuccess
  | GetUserByTokenFail
  | GetUserById
  | GetUserByIdSuccess
  | GetUserByIdFail
  | UserLogin
  | UserLoginFail
  | UserLoginSuccess
  | UpdateUserData
  | UpdateUserDataFail
  | UpdateUserDataSuccess
  | RefreshUserData
  | RefreshUserDataFail
  | RefreshUserDataSuccess
  | UserLogout
  | UserLogoutFail
  | UserLogoutSuccess;
